@if (overlayImgUrlList && overlayImgUrlList.length > 0) {
  @for (url of overlayImgUrlList ; track url; let index = $index) {
    <div class="{{overlayClassList[index]}}">
      <img src="{{overlayImgUrlList[index]}}"
        class=""
        alt="Popular Image">
    </div>
  }
}
